import { translate } from '@/utils/translations'

const NoDescriptionMessage = () => (
  <p>
    {translate('assets.show.product-description-unavailable')}
  </p>
)

export default NoDescriptionMessage
